module.exports = __webpack_public_path__ + "static/img/7_tesila.5d6c7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/7_tesila.png
// module id = /BW2
// module chunks = 0